import { MESSAGES } from '@/commons/constants/errorMessages';

export const validatePassword = (oldPassword = '') => (rule, value, callback) => {
  /**
   Минимум 10 символов.
   Должен содержать латинские буквы верхнего регистра (минимум одну).
   Должен содержать латинские буквы нижнего регистра (минимум одну).
   Должен содержать цифры (минимум одну).
   Должен содержать специальные символы (минимум один).
   Список допустимых специальных символов:  ` ~ ! @ # $ % ^ & * ( ) _ - + = { } [ ] \ | : ; « » ' < > , . ? /
   */
  const minLength = 10;

  const numRegex = new RegExp('(?=.*[0-9])', 'g');
  const specCharsRegex = new RegExp('(?=.*[`~!@#$%^&*()\\-_+={}\\[\\]|:;«»\'<>,.?/\\\\])', 'g');
  const latinCharsLowercaseRegex = new RegExp('(?=.*[a-z])', 'g');
  const latinCharsUppercaseRegex = new RegExp('(?=.*[A-Z])', 'g');
  const onlyCertainCharsRegex = new RegExp('^[0-9a-zA-Z`~!@#$%^&*()\\-_+={}\\[\\]|:;«»\'<>,.?/\\\\]+$');

  if (value === '') {
    return callback(new Error(MESSAGES.REQUIRED));
  }

  if (!numRegex.test(value)) {
    callback(new Error(MESSAGES.PASSWORD_MUST_HAVE_NUMBER));
  }

  if (!latinCharsLowercaseRegex.test(value)) {
    return callback(new Error(MESSAGES.PASSWORD_MUST_HAVE_LATIN_LOWERCASE));
  }

  if (!latinCharsUppercaseRegex.test(value)) {
    return callback(new Error(MESSAGES.PASSWORD_MUST_HAVE_LATIN_UPPERCASE));
  }

  if (!specCharsRegex.test(value)) {
    return callback(new Error(MESSAGES.PASSWORD_SPEC_CHARS));
  }

  if (!onlyCertainCharsRegex.test(value)) {
    return callback(new Error(MESSAGES.PASSWORD_OTHER_CHARS));
  }

  if (value.length < minLength) {
    return callback(new Error(MESSAGES.MIN_LENGTH(minLength)));
  }

  if (oldPassword && oldPassword === value) {
    return callback(new Error(MESSAGES.PASSWORDS_MUST_DIFFERENT));
  }

  callback();
};

export const validatePasswordMatch = (repeatNewPassword) => (rule, value, callback) => {
  if (value === '') {
    return callback(new Error(MESSAGES.REQUIRED));
  }
  if (value !== repeatNewPassword) {
    return callback(new Error(MESSAGES.PASSWORD_MISMATCH));
  }
  callback();
};
